import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { usePermission } from '../../contexts/PermissionContext';
import LoadingIndicator from '../common/LoadingIndicator';
import { useTranslation } from 'react-i18next';
import Logger from '../../utils/Logger';
import { PAGE_PERMISSION_MAP } from '../../constants/permissionConstants';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { hasCategoryPermission, hasPagePermission, loading: permissionLoading } = usePermission();
  const location = useLocation();
  const { t } = useTranslation();
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuthorization = () => {
      // 관리자 페이지 체크
      if (location.pathname.includes('/main/admin')) {
        const department = localStorage.getItem('department');
        const isAdmin = department === 'admin';

        if (!isAdmin) {
          setIsAuthorized(false);
        } else {
          // 관리자 권한 체크
          if (!hasCategoryPermission('관리자')) {
            setIsAuthorized(false);
          } else {
            // 특정 페이지 권한 체크
            const currentPath = location.pathname;
            const pageName = Object.keys(PAGE_PERMISSION_MAP['관리자'] || {})
              .find(key => PAGE_PERMISSION_MAP['관리자'][key] === currentPath);
            
            if (pageName && !hasPagePermission('관리자', pageName)) {
              setIsAuthorized(false);
            } else {
              setIsAuthorized(true);
            }
          }
        }
      } else {
        // 일반 페이지 권한 체크
        const currentPath = location.pathname;
        let hasPermission = true;
        
        // 각 카테고리별로 권한 체크
        for (const [category, pages] of Object.entries(PAGE_PERMISSION_MAP)) {
          const pageName = Object.keys(pages).find(key => pages[key] === currentPath);
          if (pageName) {
            if (!hasCategoryPermission(category) || !hasPagePermission(category, pageName)) {
              hasPermission = false;
              break;
            }
          }
        }
        
        setIsAuthorized(hasPermission);
      }
      setCheckingAuth(false);
    };

    if (!loading && !permissionLoading && isAuthenticated) {
      // Logger.log('Checking authorization, isAuthenticated:', isAuthenticated);
      checkAuthorization();
    } else {
      setCheckingAuth(false);
    }
  }, [loading, permissionLoading, isAuthenticated, location.pathname, hasCategoryPermission, hasPagePermission]);


  if (loading || permissionLoading || (isAuthenticated && checkingAuth)) {
    return <LoadingIndicator
      isLoading={true}
      message={t('common.checkingAuthentication')}
    />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!isAuthorized) {
    return <Navigate to="/main" replace />;
  }

  return children;
};

export default ProtectedRoute;